import { render, staticRenderFns } from "./TheModalCategoriaTratamiento.vue?vue&type=template&id=7d1e0216&"
import script from "./TheModalCategoriaTratamiento.vue?vue&type=script&lang=js&"
export * from "./TheModalCategoriaTratamiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports